import { render, staticRenderFns } from "./OidcRedirect.vue?vue&type=template&id=52b756a4&"
import script from "./OidcRedirect.vue?vue&type=script&lang=js&"
export * from "./OidcRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports